import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';

import { BackButton } from 'web-ui-components/lib/molecules/navigation';
import { UtilityNav } from 'web-ui-components/lib/navigation/site-navs';
import { Column, Row } from 'web-ui-components/lib/global/layout';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { ApplicationFormShell } from 'web-ui-components/lib/layout/shells';

import { getAccountDetails } from 'redux/actions/accountAction';
import { navigateToNextScreen } from 'redux/actions/navigationAction';

import { getAPIObject, accessToken, hideBackButton } from 'selectors/config';
import { routes, router } from '../routes';
import ErrorPage from './ErrorPageContainer/ErrorPage';
import HeaderComponent from '../components/HeaderComponent/HeaderComponent';
import LoaderComponent from '../components/LoaderComponent/LoaderComponent';
import RightPanel from '../components/SidePanelComponents/RightPanel';

import { Analytics } from '../utils/analytics';

Analytics.inject();

class App extends Component {
  componentDidMount() {
    const {
      baseProps,
      baseProps: {
        config: { bankId, brandId, productCode },
        content
      },
      getAccountDetails
    } = this.props;

    const apiObject = getAPIObject(baseProps);
    getAccountDetails(
      apiObject.paasExternalUrl,
      apiObject.bankId,
      apiObject.accessToken,
      apiObject.accountId,
      apiObject.uuid
    );
  }

  renderHeader = () => {
    const { baseProps } = this.props;
    const {
      error: { isError },
      config: { productCode },
      content
    } = baseProps;
    return <HeaderComponent subline={content} isError={isError} applyFor={productCode}/>;
  };

  renderUtilityNavigation = () => {
    const {
      error: { isError }
    } = this.props.baseProps;
    const hideBack = hideBackButton();
    return (
      <UtilityNav
        leftContent={
          !isError && !hideBack ? (
            <BackButton
              onClick={() => {
                this.redirectToBackScreen();
              }}
            />
          ) : (
              <div />
            )
        }
      />
    );
  };

  renderRightPanel = () => {
    const { baseProps } = this.props;
    const {
      error: { isError },
      content: { contactPanel }
    } = baseProps;
    return !isError && <RightPanel contactPanel={contactPanel} />;
  };

  redirectToBackScreen = () => {
    const { navigateToNextScreen } = this.props;
    navigateToNextScreen('/', true);
  };

  render() {
    const { baseProps } = this.props;
    const {
      error: { isError },
      loader: { isLoading },
      config,
      content,
    } = baseProps;

    if (content && Object.keys(content).length <= 0) {
      return (<div></div>);
    }
    else {
      return (
        <ApplicationFormShell
          header={this.renderHeader()}
          rightSidebar={this.renderRightPanel()}
          utilityNavigation={this.renderUtilityNavigation()}
        >
          <ErrorPage isError={isError}>
            <StandardBody>
              <Row>
                <Column xs={24}>
                  {router}
                  <LoaderComponent isOpen={isLoading} title={baseProps.content.common.loaderTitle} body={baseProps.content.common.loaderDesc} />
                </Column>
              </Row>
            </StandardBody>
          </ErrorPage>
        </ApplicationFormShell>
      );
    }
  }
}

const mapStateToProps = state => ({ baseProps: state });

const mapDispatch = dispatch =>
  bindActionCreators(
    {
      navigateToNextScreen,
      getAccountDetails
    },
    dispatch
  );

App.propTypes = {
  baseProps: PropTypes.shape({}).isRequired
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatch
  )
)(App);
